import { render } from "./system-coverage-modal.vue?vue&type=template&id=752d14dc&ts=true"
import script from "./system-coverage-modal.vue?vue&type=script&lang=ts"
export * from "./system-coverage-modal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__